<template>
  <div class="list-box">
    <div class="box-item">
      <div class="user-select-corp-tree">
        <el-form inline size="mini">
          <el-form-item style="width: 140px">
            <el-input
              prefix-icon="el-icon-search"
              placeholder="请输入内容"
              v-model="searchText"
              @keydown.enter.native="searchEvt"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="wbench-button" type="primary" @click="handleAddGroup"
              >添加用户组</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="depart-box user-select-corp-tree">
      <el-tree
        ref="orgTree"
        :data="groupList"
        default-expand-all
        node-key="id"
        class="wbench-tree-defined-special"
        :props="{ label: 'groupName', children: 'children' }"
        :current-node-key="currentNodeKey"
        :expand-on-click-node="false"
        :check-on-click-node="true"
        :highlight-current="true"
        @node-click="onOrgClick"
      >
        <template #default="{ node, data }">
          <span class="custom-tree-node wbench-tree-node-defined" :data-key="data.id">
            <span v-text="node.label"></span>
            <i class="el-icon-edit" @click="handleUpdateGroup(data)" />
            <i class="el-icon-delete" @click="handleDeleteGroup(data)" />
          </span>
        </template>
      </el-tree>
    </div>
    <div class="divider">
      <span v-if="multiEnable" @click="checkAll">全选</span>
    </div>
    <div class="user-box">
      <el-checkbox-group @change="onChange" v-model="checkList" v-if="userList.length > 0">
        <div v-for="(item, index) in userList" :key="index" class="user-item-full">
          <el-checkbox
            :label="item"
            :title="item.realName + '---' + item.corpName + item.departName"
          >
            <span class="user">{{ item.realName }}</span>
            <span class="corp">{{ item.corpName }}</span>
            <div class="clear"></div>
            <span v-if="item.userDuty" class="user">{{ item.userDuty }}</span>
            <span class="corp">{{ item.departName }}</span>
            <div class="clear"></div>
          </el-checkbox>
        </div>
      </el-checkbox-group>
      <div v-else class="user-no-data">暂无数据</div>
    </div>
    <el-dialog
      title="用户组维护"
      :visible.sync="dialogGroupVisible"
      append-to-body
      width="800px"
      class="wbench-user-select"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="用户组名称" prop="groupName">
          <el-input v-model="temp.groupName" />
        </el-form-item>
        <el-row :gutter="20" class="user-group-add-box">
          <el-col :span="12" class="user-group-box-item">
            <DepartUserList
              :multi-enable="true"
              :checked="temp.users"
              ref="departUser"
              @checkUser="checkUser"
            ></DepartUserList>
          </el-col>
          <el-col :span="1">-</el-col>
          <el-col :span="11" class="user-group-box-item">
            <div>已选择：</div>
            <div class="cell" v-for="(user, i) in temp.users" :key="i">
              {{ user.realName }}
              -
              {{ user.departName }}
              <el-button
                type="text"
                icon="el-icon-delete"
                title="删除"
                @click="temp.users.splice(i, 1)"
              ></el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogGroupVisible = false"> 取消 </el-button>
        <el-button type="primary" @click="updateGroup()"> 确认 </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { deleteGroupList, getUserGroupList, updateUserGroupList } from "../api";
import { current } from "@szgc/plt-core-v2";
import request from "../../../api/request";

export default {
  name: "GroupUserList",
  components: {
    DepartUserList: () => import("./DepartUserList")
  },
  props: {
    multiEnable: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    groupList() {
      return this.list.filter((g) => g.groupName.indexOf(this.searchText) > -1);
    }
  },
  data() {
    return {
      searchText: "",
      list: [],
      current: {
        corpId: ""
      },
      allChecked: false,
      currentNodeKey: "",
      userList: [],
      checkList: [],
      prefix: "",
      dialogStatus: "",
      dialogGroupVisible: false,
      temp: {
        groupName: "",
        users: []
      },
      rules: {
        groupName: [{ required: true, message: "请检查填写", trigger: "blur" }]
      }
    };
  },
  watch: {
    checked: {
      handler() {
        this.setChecked();
      },
      deep: true
    }
  },
  methods: {
    async handleDeleteGroup(node) {
      const res = await this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (res !== "confirm") return;
      const { userId } = this.current;
      const { success, message } = await request({
        url: this.prefix + deleteGroupList(userId, node.groupId),
        method: "delete"
      });
      if (!success) {
        return this.$message.error("删除用户组列表失败:" + message);
      }
      this.getGroupList();
    },
    handleUpdateGroup(node) {
      console.log(node);
      this.temp = JSON.parse(JSON.stringify(node));
      this.dialogGroupVisible = true;
    },
    handleAddGroup() {
      this.temp = {
        users: []
      };
      this.dialogGroupVisible = true;
    },
    checkUser() {
      const { temp } = this;
      const checkList = this.$refs.departUser.getUserData();
      !temp.users && (temp.users = []);
      checkList.forEach((user) => {
        // 检查重复 是否插入
        const isExist = this.temp.users.find((i) => i.userId === user.userId);
        if (!isExist) {
          temp.users.push(user);
          console.log(temp.users);
        }
      });
    },
    async updateGroup() {
      try {
        this.$refs["dataForm"].validate(async (valid) => {
          if (valid) {
            const { temp } = this;
            const { userId } = this.current;
            const { success, message } = await request({
              url: this.prefix + updateUserGroupList(userId),
              method: "post",
              data: {
                ownerId: userId,
                memberIds: temp.users.map((u) => u.userId),
                ...temp
              }
            });
            if (!success) {
              return this.$message.error("获取用户组列表失败:" + message);
            }
            this.dialogGroupVisible = false;
            this.getGroupList();
            this.userList = [];
          }
        });
      } catch (e) {
        this.$message.error("获取用户组列表失败:" + e);
      }
    },
    /*搜索人员*/
    async searchEvt() {
      // sss
      this.dialogGroupVisible = true;
    },
    /*勾选全项目部搜索*/
    allCheckEvt() {
      this.$refs.orgTree.setCheckedKeys([]);
      this.$refs.orgTree.setCurrentKey(null);
    },
    /*返回已选人员*/
    getUserData() {
      return [...this.checkList];
    },
    /*返回当前部门所有人员*/
    getAllUser() {
      return this.userList;
    },
    /*全选*/
    checkAll() {
      if (this.multiEnable) {
        let notRows = [];
        this.userList.map((item) => {
          notRows.push(item);
        });
        this.checkList = notRows;
      }
      this.$emit("checkUser", { data: this.userList });
    },
    /*控制单选多选*/
    onChange(list) {
      if (!this.multiEnable) {
        this.checkList = [list[list.length - 1]];
      }
      this.$emit("checkUser", { data: this.userList });
    },
    /*点击组织树某一行，查询相关人员*/
    onOrgClick(data) {
      this.userList = data.users;
    },
    /*设置选中*/
    setChecked() {
      let notRows = [];
      this.userList.map((item) => {
        let flag = false;
        this.checked.map((child) => {
          if (child.userId === item.userId) {
            flag = true;
          }
        });
        if (flag) {
          notRows.push(item);
        }
      });
      this.checkList = notRows;
    },
    async getGroupList() {
      try {
        const { userId } = this.current;
        const { success, message, data } = await request({
          url: this.prefix + getUserGroupList(userId),
          method: "get"
        });
        if (!success) {
          return this.$message.error("获取用户组列表失败:" + message);
        }
        this.list = data;
      } catch (e) {
        this.$message.error("获取用户组列表失败:" + e);
      }
    }
  },
  mounted() {
    this.current = current;
    this.getGroupList();
  }
};
</script>
<style lang="scss" scoped>
.list-box {
  width: 100%;
  height: 530px;
  overflow: hidden;

  .box-item {
    background-color: #f6f9f9;
    padding: 7px 10px;
    height: 45px;
    box-sizing: border-box;
    border-bottom: 1px solid #d8d8d8;
    overflow: hidden;
  }

  .depart-box {
    height: calc((100% - 90px) / 2);
    padding: 10px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .divider {
    height: 30px;
    background-color: #f6f9f9;
    border-top: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    box-sizing: border-box;
    line-height: 28px;

    > span {
      margin-left: 10px;
      color: var(--szgc-element-primary);
    }
  }

  .user-box {
    height: calc((100% - 80px) / 2);
    overflow-x: hidden;
    overflow-y: auto;

    .user-no-data {
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: #909399;
    }
  }
}
</style>

<style lang="scss">
.user-group-add-box {
  height: 550px;
  .user-group-box-item {
    border: 1px solid #d8d8d8;
    height: 100%;
    .cell {
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 36px;
      border-bottom: 1px solid #d8d8d8;
    }
  }
}
.custom-tree-node {
  i {
    margin: 0 5px;
    cursor: pointer;
    color: var(--szgc-element-primary);
  }
}

.user-select-pop-box {
  width: 330px;
  height: 410px;
  padding: 10px;
  border-radius: 0;
  box-shadow: none;
  border: none;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}

.user-select-corp-tree {
  span.expanded + span.custom-tree-node {
    i.el-icon-folder::before {
      content: "\e784";
    }
  }

  span.custom-tree-node-selected {
    color: var(--szgc-element-primary);
  }

  .all-search {
    position: relative;
    z-index: 999;
  }
}
</style>
